import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RestService } from '../services/rest.service';
import { WebSocketChatService } from '../services/web-socket-chat.service';
import { Subscription } from 'rxjs';
import { WebSocketContent, sender } from '../models/webSocketContent';
import { SessionService } from '../services/session.service';
import { ComunicacaoService } from '../services/comunicacao.service';
import { _colors_users, msg } from 'src/app/pages/chamados/interacao-chamado/interacao-chamado.component';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnInit, OnDestroy {
  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    this.socketOrcamento.disconect();
    this.inscricao.unsubscribe();
  }
  @Input() navBarStatus: any;
  activated: boolean = false;
  inscricao: Subscription;
  protocolo: string = null;
  aba: number = 1;
  uuidUser: string;
  userName: string;
  listaMsg: Array<msg> = [];
  listaCoresUsuarios: Array<_colors_users> = [];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    private rest: RestService,
    private socketOrcamento: WebSocketChatService,
    private session: SessionService,
    private comu: ComunicacaoService
  ) {
    this.router.events.subscribe((e: any) => {
      if (!String(e.url).includes('veiculo?protocolo=' + String(this.protocolo)) && this.inscricao != null) {
        this.inscricao = null;
        this.listaMsg = [];
        this.listaCoresUsuarios = [];
        if (this.socketOrcamento.isConnected)
          this.socketOrcamento.messages.complete();
      }
    });
    this.comu.listen().subscribe((m: any) => {
      if (m == 'reconnect-chat') {
        if (!this.protocolo) {
          this.protocolo = String(this.route.snapshot.queryParamMap.get('protocolo'));
          if (!this.protocolo) return;
        }
        this.connectarSocket(this.protocolo, true);
      }
    });
    this.uuidUser = this.session.getUUIDUsuario();
    this.userName = this.session.getNomeUsuario();
  }

  ngOnInit(): void {
    document.getElementById('msgSend').style.height = '0';//definição de altura do box de mensagens
    $("#msgSend").each(function () {//função para manter scroll na parte mais baixa do box de mensagens
      this.setAttribute("style", "height:" + (this.scrollHeight) + "px;overflow-y:hidden;");
    }).on("input", function (e) {
      this.style.height = "0";
      if (!(this.scrollHeight > 52)) {
        this.style.height = (this.scrollHeight) + "px";
        this.style.overflowY = 'hidden';
      }
      else {
        this.style.overflowY = 'scroll';
        this.style.height = "52px";
      }
    })
    document.getElementById("msgSend").addEventListener("keydown", function (event) {
      if (event.key == 'Enter' && !event.shiftKey) {//função para envio de mensagens caso o enter seja precionado sem o shift segurado
        $('.btn-send').click();
        event.preventDefault();
      }
    });
    document.addEventListener('click', this.documentClick.bind(this));
  }

  ngOnDestroy() {
    document.removeEventListener('click', this.documentClick);
  }

  documentClick(event: any) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.activated = false; // Feche o card do chat
    }
  }

  chatOrcamentoDisponivel(): boolean {
    return this.router.url.includes('veiculo?protocolo=');
  }

  carregarMensagensOrcamento(protocolo: string = this.protocolo, carregarMais: boolean = false) {
    let offset = 0;
    if (carregarMais)
      offset = this.listaMsg.length
    else
      this.listaMsg = [];
    this.rest.obterMensagensIdenpendentesOrcamento(protocolo, offset).subscribe((data: any) => {
      if (data.status == 'success') {
        data.data.forEach((msg: Array<WebSocketContent>) => {
          this.listaMsg.unshift({ "content": msg[0].content.msg, "sender_name": msg[0].sender.name, "side": msg[0].sender.uuid == this.uuidUser ? 'rigth' : 'left', "mencao": null });
          if (this.listaCoresUsuarios.findIndex((e: _colors_users) => e.user_name === msg[0].sender.name) == -1) {
            let user_color: _colors_users = new _colors_users();
            user_color.user_name = msg[0].sender.name;
            this.listaCoresUsuarios.push(user_color);
          }
        });
      }
    });
  }

  alterarChat(chat) {//alternador de chat entre chat de suporte e chat de orçamento
    //chat = 0: chat suporte
    //chat = 1: chat orçamento
    $('.btn-nav-chat').removeClass('select');
    $('.btn-nav-chat')[chat].classList.add('select');
    if (chat == 1) {//chat de orçamento
      let p = String(this.route.snapshot.queryParamMap.get('protocolo'));
      if (p && p != null) {
        this.protocolo = p;
        this.connectarSocket(p);
      }
    }
  }

  connectarSocket(protocolo, reconect: boolean = false) {
    if (!reconect && !this.socketOrcamento.isConnected) {
      if (!protocolo) protocolo = this.obterProtocoloOrcamento();
      this.rest.obterUrlWebSocketDoOrcamento(protocolo).subscribe((data: any) => {
        if (data.status == 'sucesso') {
          if (!reconect) {
            this.socketOrcamento.webSocketConnect(data.url);
            this.inscreverSocket();
          }
          else {
            this.socketOrcamento.webSocketReconnect(data.url);
          }
          if (this.aba == 1) {
            this.carregarMensagensOrcamento(protocolo);
          }
        }
      });
    }
  }

  inscreverSocket() {
    this.inscricao = this.socketOrcamento.messages.subscribe((msg: WebSocketContent) => {
      if (msg.code == 42 && msg.sender.uuid != this.uuidUser && msg.uuid_orcamento == this.protocolo) {
        this.listaMsg.push({ "content": msg.content.msg, "sender_name": msg.sender.name, "side": msg.sender.uuid == this.uuidUser ? 'rigth' : 'left', "mencao": null });
        if (this.listaCoresUsuarios.findIndex((e: _colors_users) => e.user_name === msg.sender.name) == -1) {
          let user_color: _colors_users = new _colors_users();
          user_color.user_name = msg.sender.name;
          this.listaCoresUsuarios.push(user_color);
        }
      }
    });
  }

  enviar() {
    if (!this.chatOrcamentoDisponivel() && this.aba == 1) return;
    let msg = $('#msgSend').val();
    if (msg) {
      let socketContent: WebSocketContent = new WebSocketContent();
      let _sender: sender = new sender()
      _sender.name = this.userName;
      _sender.uuid = this.uuidUser;
      socketContent.sender = _sender;
      socketContent.type_recipient = 'orcamento';
      socketContent.recipient = this.protocolo;
      socketContent.uuid_orcamento = this.protocolo;
      if (this.listaCoresUsuarios.findIndex((e: _colors_users) => e.user_name === socketContent.sender.name) == -1) {
        let user_color: _colors_users = new _colors_users();
        user_color.user_name = socketContent.sender.name;
        this.listaCoresUsuarios.push(user_color);
      }
      if (this.aba == 1) {
        socketContent.code = 42;
        socketContent.content = { "msg": msg };
        this.listaMsg.push({ "content": socketContent.content.msg, "sender_name": socketContent.sender.name, "side": socketContent.sender.uuid == this.uuidUser ? 'rigth' : 'left', "mencao": null });
      }
      this.enviarSocket(socketContent);
      $('#msgSend').val(null);
    }
  }

  enviarSocket(json: WebSocketContent) {
    this.socketOrcamento.messages.next(json);
  }

  toggle() {
    this.activated = !this.activated;
    this.verificaOrcamento();
  }

  obterProtocoloOrcamento(): string {
    this.protocolo = String(this.route.snapshot.queryParamMap.get('protocolo'));
    return String(this.route.snapshot.queryParamMap.get('protocolo'));
  }

  verificaOrcamento() {
    if (this.aba == 1 && this.chatOrcamentoDisponivel()) {
      let p = this.obterProtocoloOrcamento();
      if (p) {
        this.connectarSocket(p);
      }
    }
  }

  retornaCorDoUsuario(user_name: string): string {
    let cor: string = this.listaCoresUsuarios[this.listaCoresUsuarios.findIndex((e: _colors_users) => e.user_name === user_name)].color;
    return cor ? cor : new _colors_users().color;
  }
}